import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ModalProgressBar } from "../../_metronic/_partials/controls";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { withRouter } from "react-router";
import { makeGetUser } from '../acl/user/_redux/userSelectors';
import { userActions } from '../acl/user/_redux/userActions';
import { userService } from '../acl/user/_redux/userServices';
import evbus from '../../shared/eventBus';
import { tenantService } from '../tenant/_redux/tenantServices';
import { withTranslation } from "react-i18next";
import { utils } from "../../shared/utils"
import _ from 'lodash';
import { SubHeaderActions } from '../../_metronic/layout/components/subheader/SubHeaderActions';


const defUser = {
  id: '',
  username: '',
  clear: true,
  enabled: true,
  tenant_id: "",
  user_profile: {
    full_name: '',
    job_title: '',
    user_email: '',
    phone_number: '',
  }  
};

class UserPersonalInformation extends React.Component {
  state = {
    user: this.props.user,
    oldUser: this.props.user,
    savingObject: false,
    savedObject: false,
    hasChangesObject: false,
    showWarning: false,
    sendingEmailToken: false,
    emailTokenCooldown: false,
    lastSentEmail: "", // to track when email changes
    }


  componentDidMount() {
    const { user } = this.state;
      userService.load(user.id)
        .then((luser) => {
          this.setState(prevState => ({
            ...prevState,
            user: { ...defUser, ...luser },
            oldUser: user,
          }));
        });
  }

  componentWillUnmount() {
    this.props.setPageTitle(null);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.user?.user_profile?.full_name !== this.state.user?.user_profile?.full_name) {
      this.props.setPageTitle(this.state.user.username);
      this.updatePageElements();
    }
    const prevEmail = prevState.user?.user_profile?.user_email;
  const currentEmail = this.state.user?.user_profile?.user_email;

  if (prevEmail !== currentEmail) {
    // Re-enable sending if user changed email
    this.setState({ emailTokenCooldown: false });
  }
  }

  updatePageElements = () => {
    // Example: Force refresh data, update DOM elements, etc.
    this.setState({ forceRender: true });
  };
  checkChanges = () => {
    const { user, oldUser, hasChangesObject } = this.state;
    let changed = !utils.compareArrays(user, oldUser);
    if (hasChangesObject !== changed) {
      this.setState({ hasChangesObject: changed });
    }
  }

  // handleFormChange = (e) => {
  //   let { name, value, type } = e.target;
  
  //   // Ensure we properly update user state
  //   this.setState(prevState => ({
  //     ...prevState,
  //     user: {
  //       ...prevState.user,
  //       [name]: value, // Assign new value to the specific field
  //     }
  //   }), () => this.checkChanges());
  // };
  
  handleSubmit = (values, { setSubmitting }) => {
   this.setState(prevState => ({
    ...prevState,
    user: {
      ...prevState.user,
      user_profile: {
        ...prevState.user.user_profile,
        full_name: values.full_name,
        phone_number: values.phone_number,
        user_email: values.user_email,
      }
    }
  }), () => {
    
    this.props.save(this.state.user, this.props.history, (error) => {
      if (error) {
        evbus.emit("NOTIFICATION", { type: "error", message: error.message || error.toString() });
      }

      this.setState({ savingObject: false, savedObject: true, oldUser: this.state.user }, () => {
        setSubmitting(false);  
        this.checkChanges();
      });
    });
  });
  }

  handleSendEmailToken = () => {
    const { user,emailTokenCooldown } = this.state;
    const user_email = user?.user_profile?.user_email;
  
    if (!user.id) {
      evbus.emit("NOTIFICATION", { type: "error", message: "User ID is missing, please refresh and try again." });
      return;
    }
  
    if (!user?.user_profile?.user_email) {
      evbus.emit("NOTIFICATION", { type: "error", message: "Email is required to send verification token." });
      return;
    }

  this.setState({ sendingEmailToken: true }, () => {
    this.props.sendVerificationEmail(
      user.id,
      (err) => {
        // error callback
        evbus.emit("NOTIFICATION", {
          type: "error",
          message: err.message || err.toString(),
        });
        this.setState({ sendingEmailToken: false });
      },
      () => {
        // success callback
        evbus.emit("NOTIFICATION", {
          type: "success",
          message: "Verification token sent successfully!",
        });
    
        this.setState({
          emailTokenCooldown: true,
          lastSentEmail: user_email,
        });
    
        setTimeout(() => {
          this.setState({ emailTokenCooldown: false });
        }, 60000);
    
        this.setState({ sendingEmailToken: false });
      }
    );    
  });
};

  handleVerifyEmailToken = (token) => {
    const { user } = this.state;
  
    if (!token) {
      evbus.emit("NOTIFICATION", { type: "error", message: "Please enter the verification token." });
      return;
    }
  
    this.props.verifiyEmailToken(user.id, token, (response) => {
      const isError = response && (response.error || response instanceof Error || typeof response === "string");
  
      if (isError) {
        const message = response.message || response.toString();
        evbus.emit("NOTIFICATION", {
          type: "error",
          message,
        });
      } else {
        console.log("Verification response:", response);
        evbus.emit("NOTIFICATION", {
          type: "success",
          message: response.message || "Email verified successfully!",
        });
      }
    });
  };
    
  removePic = () => {
    this.setState({ pic: "" });
  };

  getInputClasses = (fieldname, touched, errors) => {
    if (touched[fieldname] && errors[fieldname]) {
      return "is-invalid";
    }
    if (touched[fieldname] && !errors[fieldname]) {
      return "is-valid";
    }
    return "";
  };

  render() {
    const { user, savingObject,emailTokenCooldown,sendingEmailToken } = this.state;

    return (
      <Formik
        enableReinitialize={true} 
        initialValues={{
          pic: this.state.pic,
          full_name: this.state.user?.user_profile.full_name	 || "",
          phone_number: this.state.user?.user_profile.phone_number || "",
          user_email: this.state.user?.user_profile.user_email || "",
          email_token: "",
        }}
        validationSchema={Yup.object().shape({
          full_name: Yup.string().required(this.props.t("Full name is required")),
          phone_number: Yup.string().required(this.props.t("Phone is required")),
          user_email: Yup.string()
            .email(this.props.t("Wrong email format"))
            .required(this.props.t("Email is required")),
        })}
        onSubmit={this.handleSubmit}
      >
        {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
          <Form className="card card-custom card-stretch">
            {this.state.loading && <ModalProgressBar />}

            {/* Header */}
            <div className="card-header py-3">
              <div className="card-title align-items-start flex-column">
                <h3 className="card-label font-weight-bolder text-dark">{this.props.t("Personal Information")}</h3>
                <span className="text-muted font-weight-bold font-size-sm mt-1">
                  {this.props.t("Update your personal information")}
                </span>
              </div>
              <div className="card-toolbar">
                <button
                  type="submit"
                  className="btn btn-success mr-2"
                  disabled={isSubmitting}
                >
                  Save Changes
                </button>
                <Link to="/user-profile/profile-overview" className="btn btn-secondary">
                  Cancel
                </Link>
              </div>
            </div>

            {/* Form Content */}
            <div className="form">
              <div className="card-body">
                {/* Avatar Upload */}
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">Avatar</label>
                  <div className="col-lg-9 col-xl-6">
                    <div
                      className="image-input image-input-outline"
                      id="kt_profile_avatar"
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl("/media/users/blank.png")})`,
                      }}
                    >
                      <div className="image-input-wrapper" style={{ backgroundImage: `url(${this.state.pic})` }} />
                      <span
                        onClick={this.removePic}
                        className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                        data-action="remove"
                      >
                        <i className="ki ki-bold-close icon-xs text-muted"></i>
                      </span>
                    </div>
                    <span className="form-text text-muted">Allowed file types: png, jpg, jpeg.</span>
                  </div>
                </div>

                {/* Full Name */}
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">{this.props.t("Full Name")}</label>
                  <div className="col-lg-9 col-xl-6">
                    <Field
                      type="text"
                      name="full_name"
                      placeholder={this.props.t("Full name")}
                      className={`form-control form-control-lg form-control-solid ${this.getInputClasses("full_name", touched, errors)}`}
                    />
                    <ErrorMessage name="full_name" component="div" className="invalid-feedback" />
                  </div>
                </div>

                {/* Phone */}
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">{this.props.t("Contact Phone")}</label>
                  <div className="col-lg-9 col-xl-6">
                    <Field
                      type="text"
                      name="phone_number"
                      placeholder={this.props.t("Phone")}
                      className={`form-control form-control-lg form-control-solid ${this.getInputClasses("phone_number", touched, errors)}`}
                    />
                    <ErrorMessage name="phone_number" component="div" className="invalid-feedback" />
                  </div>
                </div>

                {/* Email */}
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label">{this.props.t("Email Address")}</label>
                  <div className="col-lg-9 col-xl-6">
                    <Field
                      type="email"
                      name="user_email"
                      placeholder="Email"
                      className={`form-control form-control-lg form-control-solid ${this.getInputClasses("user_email", touched, errors)}`}
                    />
                    <ErrorMessage name="user_email" component="div" className="invalid-feedback" />
                  </div>
                </div>

              {/* Send Email Token Button */}
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">{this.props.t("Verify Email")}</label>
                <div className="col-lg-9 col-xl-6">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => this.handleSendEmailToken()}
                    disabled={this.state.sendingEmailToken || this.state.emailTokenCooldown || user?.user_profile?.email_is_verified}
                  >
                    {this.state.sendingEmailToken ? (
                      <>
                      <span className="spinner spinner-white mr-2"></span> {this.props.t("Sending...")}
                      </>
                      ) : this.state.emailTokenCooldown ? (
                        this.props.t("Please wait...")
                      ) : (user?.user_profile?.email_is_verified ? this.props.t("Email is Verified") :
                        this.props.t("Send Verification Token")
                      )}
                  </button>
                  <ErrorMessage name="user_email" component="div" className="invalid-feedback" />
                </div>
              </div>

              {/* Email Token Input */}
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">{this.props.t("Email Token")}</label>
                <div className="col-lg-9 col-xl-6">
                  <Field
                    type="text"
                    name="email_token"
                    placeholder={user?.user_profile?.email_is_verified ? this.props.t("Email is Verified"):this.props.t("Enter token")}
                    disabled={user?.user_profile?.email_is_verified}
                    className={`form-control form-control-lg form-control-solid ${this.getInputClasses("email_token", touched, errors)}`}
                  />
                  <ErrorMessage name="email_token" component="div" className="invalid-feedback" />
                </div>
              </div>

              {/* Verify Email Token Button */}
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label"></label>
                <div className="col-lg-9 col-xl-6">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => this.handleVerifyEmailToken(values.email_token)}
                    disabled={user?.user_profile?.email_is_verified}
                  >
                    {this.props.t("Verify Token")}
                  </button>
                </div>
              </div>

              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

UserPersonalInformation.propTypes = {
  save: PropTypes.func,
  invalidate: PropTypes.func,
  history: PropTypes.object,
  match: PropTypes.object,
  user: PropTypes.object,
  requestSaveActive: PropTypes.bool,
  sendVerificationEmail: PropTypes.func,
  verifiyEmailToken: PropTypes.func,
  sendingEmailToken: PropTypes.bool,
  emailTokenCooldown: PropTypes.bool,
};

const makeMapState = () => {
  const getUser = makeGetUser();
  const defaultProfile = {
    full_name: '',
    job_title: '',
    user_email: '',
    phone_number: '',
  };
  
  
  return function mapState(state, props) {
    const authUser = state.auth ? state.auth.user : {};
    const userProfile = {
      ...defaultProfile,
      ...(authUser?.user_profile || {}),
    };
   
    return {
      user: {
        ...authUser,  
        id: authUser.user_id || "",
        user_profile: userProfile, 
      },
      requestSaveActive: state.user ? state.user.requestSaveActive : false,
      sendingEmailToken: state.user ? state.sendingEmailToken : false,
      emailTokenCooldown: state.user ? state.emailTokenCooldown : false,
      auth: state.auth || {},
    };
  };
};

const actionCreators = {
  save: userActions.save,
  sendVerificationEmail: userActions.sendToken,
  verifiyEmailToken: userActions.checkToken,
  invalidate: userActions.invalidate,
  setPageTitle: SubHeaderActions.setPageTitle,
}

export default withTranslation()(withRouter(connect(makeMapState, actionCreators)(UserPersonalInformation)));

